import React from 'react';
import './TechToolList.scss';

interface TechToolListProps {
  children: React.ReactNode;
}

export default function TechToolList({ children }: TechToolListProps) {
  return (
    <ul className='techtool-list' aria-label='techtool list'>
      {children}
    </ul>
  );
}
